"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const redux_observable_1 = require("redux-observable");
const current_1 = require("./current");
const forgotPassword_1 = require("./forgotPassword");
const login_1 = require("./login");
const oauth2_1 = require("./oauth2");
const resetPassword_1 = require("./resetPassword");
const zendesk_1 = require("./zendesk");
exports.allEpics = redux_observable_1.combineEpics(
// Current
current_1.getUserInfo, current_1.getUserFeatures, current_1.refreshToken, current_1.updateLanguage, current_1.updateUserInfo, 
// Forgot Password
forgotPassword_1.sendForgotPasswordEmail, 
// Login
login_1.exchangeCodeForTokens, login_1.isFederatedUser, login_1.login, 
// Oauth2
oauth2_1.getOauth2Client, 
// Reset Password
resetPassword_1.resetPassword, resetPassword_1.resendVerifyEmail, 
// Zendesk
zendesk_1.zendeskToken);
//# sourceMappingURL=index.js.map